const MAP = {
  red: "#F43F5E", gold: "#C20511", yellow: "#FBBF24", cyan: "#00B4D8",
  green: "#10B981", blue: "#38BDF8", purple: "#A855F7", copper: "#E67332",
};

// Meaning-coded technical alert / status badge.
export function AlertBadge({ level = "yellow", children, testid }) {
  const c = MAP[level] || MAP.yellow;
  return (
    <span data-testid={testid}
      className="inline-flex items-center gap-1.5 rounded-[3px] px-2 py-0.5 text-[10px] font-mono font-semibold uppercase tracking-wider whitespace-nowrap"
      style={{ color: c, background: `${c}1F`, border: `1px solid ${c}59` }}>
      {children}
    </span>
  );
}
